export default __webpack_public_path__ + "static/media/HEINEKEN_A5_1.32c256e1.png";